import types from "./types";

const initialState = {
  screenshot: null
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SCREENSHOT:
      return {
        ...state,
        screenshot: action.payload.screenshot
      }

    default:
      return state;
  }
}

export default reportReducer;
